export const eventLabelGroupsConstants = {
  CHAT_LABEL_GROUP: "DigitalMeeting.Chat",
  CLIENTLIST_LABEL_GROUP: "DigitalMeeting.ClientList",
  EXHIBITOR_LABEL_GROUP: "DigitalMeeting.Exhibitor",
  BREAKOUT_LABEL_GROUP: "DigitalMeeting.Breakout",
  AGENDA_LABEL_GROUP: "DigitalMeeting.Agenda",
  VONAGE_LABEL_GROUP: "DigitalMeeting.Vonage",
  SPEAKER_CONTROL_LABEL_GROUP: "DigitalMeeting.SpeakerControl",
  SPEAKER_CARD_LABEL_GROUP: "DigitalMeeting.SpeakerCard",
};
